"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontScale = exports.calcSpace = exports.TYPOGRAPHY = exports.SCALE = exports.PLANE = exports.MOTION = exports.LINE = exports.LAYOUT = exports.COLOR = exports.hopinTheme = void 0;
var tslib_1 = require("tslib");
var hopin_theme_1 = require("./hopin-theme");
Object.defineProperty(exports, "hopinTheme", { enumerable: true, get: function () { return hopin_theme_1.hopinTheme; } });
exports.COLOR = tslib_1.__importStar(require("./partials/color"));
exports.LAYOUT = tslib_1.__importStar(require("./partials/layout"));
exports.LINE = tslib_1.__importStar(require("./partials/line"));
exports.MOTION = tslib_1.__importStar(require("./partials/motion"));
exports.PLANE = tslib_1.__importStar(require("./partials/plane"));
exports.SCALE = tslib_1.__importStar(require("./partials/scale"));
exports.TYPOGRAPHY = tslib_1.__importStar(require("./partials/typography"));
var calc_space_1 = require("./partials/scale/calc-space");
Object.defineProperty(exports, "calcSpace", { enumerable: true, get: function () { return calc_space_1.calcSpace; } });
var get_font_scale_1 = require("./partials/typography/get-font-scale");
Object.defineProperty(exports, "getFontScale", { enumerable: true, get: function () { return get_font_scale_1.getFontScale; } });
//# sourceMappingURL=index.js.map